module.exports = __webpack_public_path__ + "static/media/im.ed29d9ff.svg";